/** @jsx jsx */
import { createContext, useContext } from 'react';

export const MultiItemSelectContext = createContext(null);

export const useMultiItemSelectContext = () => useContext(MultiItemSelectContext);
